import PageWrapper from "app/components/page-wrapper/page-wrapper";
import { FC } from "react";
import { useGetIdosQuery } from "store/api/new.api";
import { useAccount } from "wagmi";
import FullScreenLoader from "../components/loader/FullScreenLoader";
import IdoProject from "../components/main-projects/IdoProject";
import { idoFilters } from "../config";

import styles from "./RefStatistics.module.scss";

const RefStatistics: FC = () => {
  const { address } = useAccount();
  const { data: idos, isLoading } = useGetIdosQuery({
    address,
    page: 1,
    limit: 100,
  });

  if (isLoading || !idos) {
    return <FullScreenLoader isLoading={isLoading} />;
  }

  return (
    <PageWrapper>
      <div className={styles.main}>
        <div className={styles.content}>
          <div className={styles.wrapper}>
            <IdoProject
              isStats
              search={false}
              data={{ items: idos.list ?? [] }}
              title="Your IDO statistics"
              description="Choise the IDO and get your statistics"
              filters={idoFilters}
            />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default RefStatistics;
